import { createStandaloneToast } from "@chakra-ui/react";
import type { PERSISTENT_BANNER_TYPES } from "components/notificationBanner/NotificationBanner";
import { Snackbar } from "components/snackbar/Snackbar";
import { makeAutoObservable, runInAction } from "mobx";
import React from "react";
import { timescaleTheme } from "theme";

type ToastType = "success" | "warning" | "error";
const { toast } = createStandaloneToast({ theme: timescaleTheme });

export class NotificationStore {
  activePersistentBanner?: PERSISTENT_BANNER_TYPES;
  height: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  showSuccessToaster = (message: string) => {
    this._makeToast({ type: "success", message });
  };

  showInfoToaster = (message: string) => {
    this._makeToast({ type: "warning", message });
  };

  showErrorToaster = (message: string, duration?: number) => {
    this._makeToast({ type: "error", message, duration });
  };

  _makeToast = ({
    type,
    message,
    duration,
  }: {
    type: ToastType;
    message: string;
    duration?: number;
  }) => {
    const toastIdRef = toast({
      position: "bottom-right",
      duration,
      render: () =>
        React.createElement(
          Snackbar,
          { type, onClose: () => this._closeToast({ toastIdRef }) },
          message,
        ),
    });
  };

  _closeToast = ({ toastIdRef }: any) => {
    toast.close(toastIdRef);
  };

  setHeight = (height: number) => {
    runInAction(() => (this.height = height + 103));
  };

  // Persistent Banners that show at the very top of the page
  setPersistentBanner = (type: PERSISTENT_BANNER_TYPES) => {
    runInAction(() => {
      this.activePersistentBanner = type;
    });
  };

  clearPersistentBanner = () => {
    runInAction(() => {
      this.activePersistentBanner = undefined;
    });
  };
}

export const notificationStore = new NotificationStore();
